import styled from 'styled-components'
import { LineItem } from '@components/CartDrawer/LineItem/LineItem'
import { KlarnaPlacement } from '@velasca/ui/klarna-placement'
import { Separator } from '@velasca/ui/separator'

export const MobileSeparator = styled(Separator)`
  display: block;

  @media screen and (min-width: 768px) {
    display: none;
  }
`

export const DesktopSuggestedProducts = styled.div`
  display: none;

  @media screen and (min-width: 768px) {
    width: 100%;
    max-width: 100%;
    padding: 2rem;
    display: inline-block;
  }
`

export const MobileSuggestedProducts = styled.div`
  display: inline-block;
  max-width: 100%;
  width: 100%;
  padding-bottom: 3rem;
  background: ${({ theme }) => theme.colors.sliderBackground};

  @media screen and (min-width: 768px) {
    display: none;
  }
`

export const MainSection = styled.div`
  width: 100%;

  @media screen and (min-width: 768px) {
    width: 60%;
  }
`

export const LineItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background-color: ${({ theme }) => theme.colors.background};
  padding: 2rem 2rem 0 2rem;

  @media screen and (min-width: 768px) {
    background-color: transparent;
    padding: 2rem 2.8rem;
  }
`

export const StyledLineItem = styled(LineItem)`
  @media screen and (min-width: 992px) {
    padding: 0 8.2rem;
  }
`

export const DesktopStickyWrapper = styled.div<{ topOffset: number }>`
  @media screen and (min-width: 768px) {
    position: sticky;
    top: ${({ topOffset }) => `${topOffset}px`};
  }
`

export const SummarySection = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background};

  @media screen and (min-width: 768px) {
    width: 40%;
    max-width: 500px;
    border-left: 0.1rem solid ${({ theme }) => theme.colors.secondary};
    border-right: 0.1rem solid ${({ theme }) => theme.colors.secondary};
  }
`

const SummaryTitle = styled.div`
  padding: 2rem;
  text-align: center;
  background: ${({ theme }) => theme.colors.modalBackground};
`

export const MobileSummaryTitle = styled(SummaryTitle)`
  @media screen and (min-width: 768px) {
    display: none;
  }
`

export const DesktopSummaryTitle = styled(SummaryTitle)`
  display: none;

  @media screen and (min-width: 768px) {
    display: block;
  }
`

export const SummaryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 2rem 2rem 2rem;

  @media screen and (min-width: 768px) {
    padding: 2rem 3rem;
  }
`

export const SummaryItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const SummaryItem = styled.div`
  display: flex;
  gap: 1.7rem;
  justify-content: space-between;
  align-items: baseline;
`

export const CheckoutForm = styled.form`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`

export const SummaryIcon = styled.div<{ width?: string; height?: string }>`
  svg {
    display: block;
    width: ${({ width }) => width ?? 'auto'};
    height: ${({ height }) => height ?? 'auto'};
  }
`

export const StickyCheckout = styled.form<{ isStuck?: boolean }>`
  position: sticky;
  bottom: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.3rem;
  text-align: center;
  width: 100%;
  background: ${({ theme }) => theme.colors.boxBackground};
  box-shadow: ${({ isStuck }) =>
    isStuck ? 'none' : '0px -4px 6px rgba(0, 0, 0, 0.1)'};
  padding: 2rem;

  @media screen and (min-width: 768px) {
    display: none;
  }
`

export const BottomPageSeparator = styled.div`
  background: ${({ theme }) => theme.colors.sliderBackground};

  ${Separator} {
    margin: 0;
  }

  @media screen and (min-width: 768px) {
    display: none;
  }
`

export const MediaSeparator = styled(Separator)`
  display: none;

  @media screen and (min-width: 768px) {
    display: block;
  }
`

export const StyledKlarnaPlacement = styled(KlarnaPlacement)`
  margin: 0 auto;

  klarna-placement {
    &::part(osm-message) {
      margin-bottom: 1rem;
      padding: 0;
    }
  }
`

const SummaryCheckoutButtonContainer = styled.div`
  width: 100%;
  max-width: 25rem;
`

export const MobileSummaryCheckoutButtonContainer = styled(
  SummaryCheckoutButtonContainer,
)`
  display: block;

  @media screen and (min-width: 768px) {
    display: none;
  }
`

export const DesktopSummaryCheckoutButtonContainer = styled(
  SummaryCheckoutButtonContainer,
)`
  display: none;

  @media screen and (min-width: 768px) {
    display: block;
  }
`
